import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useCurrencyStore } from '../lib/currencyStore';
import { formatPrice } from '../utils/formatPrice';
import { slugify } from '../utils/slugify';
import CardImage from './CardImage';
import { EnergyIcon } from './icons/EnergyIcon';

interface TopPortfolioCard {
  id: string;
  name: string;
  number: string;
  set: {
    name: string;
    series: string;
  };
  types?: string[];
  market_price_trend_usd: number;
  cardmarket_trend_price?: number;
  quantity: number;
}

interface TopPortfolioCardsProps {
  cards: TopPortfolioCard[];
}

export default function TopPortfolioCards({ cards }: TopPortfolioCardsProps) {
  const { currency } = useCurrencyStore();
  const navigate = useNavigate();

  const handleCardClick = (card: TopPortfolioCard) => {
    const seriesSlug = slugify(card.set.series);
    const setSlug = slugify(card.set.name);
    const cardSlug = `${slugify(card.name)}-${card.number}`;
    navigate(`/${seriesSlug}/${setSlug}/${cardSlug}`);
  };

  return (
    <>
      {cards.map((card) => (
        <article
          key={card.id}
          onClick={() => handleCardClick(card)}
          className="group relative bg-black/50 rounded-lg overflow-hidden cursor-pointer hover:ring-2 hover:ring-white/25 transition-all"
        >
          <div className="relative aspect-[2.5/3.5]">
            <CardImage
              src={`https://yjzlookljahphgxcwpnv.supabase.co/storage/v1/object/public/pokemon-images-webp/pokemon_cards/${card.id}_small.webp`}
              alt={card.name}
              cardId={card.id}
              className="absolute inset-0 w-full h-full object-cover"
              width={245}
              quality={75}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity">
              <div className="absolute bottom-0 inset-x-0 p-3">
                <div className="flex items-center justify-between mb-1">
                  <div>
                    <p className="text-sm font-medium text-white truncate">{card.name}</p>
                    <p className="text-xs text-white/60">
                      {card.number} · {card.set.name}
                    </p>
                  </div>
                  {card.types?.[0] && (
                    <EnergyIcon type={card.types[0]} />
                  )}
                </div>
                <div className="flex items-center justify-between">
                  <p className="text-sm font-medium text-white/80">
                    {/* Use market_price_trend_usd as priority */}
                    {formatPrice(card.market_price_trend_usd || card.cardmarket_trend_price, currency)}
                  </p>
                  <p className="text-xs text-white/60">
                    Qty: {card.quantity}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </article>
      ))}
    </>
  );
}